import React, {memo} from "react";
import PropTypes from "prop-types";
import {makeStyles} from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import HighlightOffRoundedIcon from "@material-ui/icons/HighlightOffRounded";
import useInfo from "./useInfo";

const useStyles = makeStyles(theme => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        borderRadius: "0.5rem",
        boxShadow: theme.shadows[5],
    },
}));

export const CustomInfoModal = memo(
    props => {
        const {type, open, setOpen, gif, img, showButton, buttonText} = props;
        const classes = useStyles();

        const info = useInfo(type);
        const title = info?.[0]?.title || "";
        const description = info?.[0]?.description || [];
        const icon = info?.[0]?.icon || "";

        return (
            <Fade in={open}>
                <div className="custom-info-modal">
                    <div
                        className="dark_overlay_modal"
                        onClick={() => {
                            setOpen(false);
                        }}
                    />
                    <div className={`customModal ${classes.paper}`}>
                        <div className="content">
                            <button
                                type="button"
                                className="close position-absolute top-0 right-0"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => setOpen(false)}
                            >
                                <HighlightOffRoundedIcon fontSize="large" />
                            </button>
                            {icon ? <i className={icon} /> : null}
                            <h3 className={` ${!icon && !description && !gif && !img ? "my-auto" : "mb-7"}`}>
                                {title}
                            </h3>
                            {description !== undefined ? (
                                <>
                                    {description.map((descr, i) => (
                                        <p key={i}>
                                            {descr}
                                            <br />
                                        </p>
                                    ))}
                                </>
                            ) : null}
                            {gif ? (
                                <iframe
                                    title="iframe"
                                    src={gif}
                                    frameBorder="0"
                                    allow="autoplay; fullscreen"
                                    allowFullScreen
                                />
                            ) : null}
                            {img ? <img style={{height: "385px", width: "785px"}} src={img} alt="modalImg" /> : null}
                        </div>

                        {showButton ? (
                            <div className="d-flex justify-content-between">
                                <button className="btn btn-primary" onClick={() => setOpen(false)}>
                                    {buttonText}
                                </button>
                            </div>
                        ) : null}
                    </div>
                </div>
            </Fade>
        );
    },
    (prevProps, nextProps) =>
        prevProps.type === nextProps.type &&
        prevProps.open === nextProps.open &&
        prevProps.gif === nextProps.gif &&
        prevProps.img === nextProps.img &&
        prevProps.buttonText === nextProps.buttonText
);

CustomInfoModal.propTypes = {
    type: PropTypes.string,
    setOpen: PropTypes.func,
    gif: PropTypes.string,
    img: PropTypes.string,
    showButton: PropTypes.bool,
    buttonText: PropTypes.string,
};
